<template>
  <transition>
    <div
      ref="breathing_lamp"
      class="ballBtn"
      :class="this.$Base.langPicClass() == 'vi-VN' ? 'ballBtn-vi' : ''"
      @touchstart.stop="handleTouchStart"
      @touchmove.prevent.stop="handleTouchMove($event)"
      @touchend.stop="handleTouchEnd"
      @click.stop="onclick()"
      :style="{
        left: left + 'px',
        top: top + 'px',
        width: itemWidth + 'px',
        height: itemHeight + 'px',
        opacity: opacity,
      }"
      v-if="isShow"
    ></div>
  </transition>
</template>
<script>
export default {
  props: {
    // 球宽度默认：“40”
    itemWidth: {
      type: Number,
      default: 50,
    },
    // 球高度默认：“40”
    itemHeight: {
      type: Number,
      default: 50,
    },
  },
  data() {
    return {
      left: 0, // 距离左边距离
      top: 0, // 距离抬头距离
      startToMove: false, // 开始移动时候不显示
      isShow: true, // 组件是否显示
      timer: null, // 定时器
      currentTop: null, // 获取当前页面的滚动条纵坐标位置
      clientW: document.documentElement.clientWidth, //视口宽
      clientH: document.documentElement.clientHeight, //视口高
      isTouch: true,
      opacity: 1,
    };
  },
  created() {
    // 初始化定义距离四周距离
    this.left = this.clientW - this.itemWidth - 0;
    this.top = this.clientH / 2 - this.itemHeight / 2;
    this.timer = setInterval(() => {
      this.left = this.left + 30;
      clearInterval(this.timer);
      this.timer = null;
      this.opacity = 0.5;
    }, 3000);
  },
  methods: {
    // 点击小球事件
    onclick() {
      this.$parent.menuBtn();
      this.opacity = 1;
    }, // 开始移动方法

    handleTouchStart() {
      this.startToMove = true;
      this.$refs.breathing_lamp.style.transition = "none";
    }, // 移动中方法

    handleTouchMove(e) {
      this.opacity = 1;
      const clientX = e.targetTouches[0].clientX; //手指相对视口的x
      const clientY = e.targetTouches[0].clientY; //手指相对视口的y
      const isInScreen =
        clientX <= this.clientW &&
        clientX >= 0 &&
        clientY <= this.clientH &&
        clientY >= 0;
      if (this.startToMove && e.targetTouches.length === 1) {
        console.log("jinlai");
        if (isInScreen) {
          this.left = clientX - this.itemWidth / 2;
          this.top = clientY - this.itemHeight / 2;
        }
      }
    }, // 移动结束方法

    handleTouchEnd() {
      clearInterval(this.timer);
      this.timer = null;
      if (this.left < this.clientW / 2) {
        this.left = 0; //不让贴边 所以设置30没设置0
        this.handleIconY();
        // left值结束3秒执行
        this.timer = setInterval(() => {
          this.left = 0 - 30;
          console.log("left", this.left);
          clearInterval(this.timer);
          this.timer = null;
          this.opacity = 0.5;
        }, 3000);
      } else {
        this.left = this.clientW - this.itemWidth - 0; //距边30px
        this.handleIconY();
        this.timer = setInterval(() => {
          this.left = this.clientW - this.itemWidth + 30;
          clearInterval(this.timer);
          this.timer = null;
          this.opacity = 0.5;
        }, 3000);
      }
      this.$refs.breathing_lamp.style.transition = "all .3s";
    }, // 上下不贴边方法

    handleIconY() {
      if (this.top < 0) {
        this.top = 0; //不上帖上边所以设置为30 没设置0
      } else if (this.top + this.itemHeight > this.clientH) {
        this.top = this.clientH - this.itemHeight - 0; //距边30px
      }
    },
  },
};
</script>
<style>
.ballBtn,
.ballBtn-vi {
  position: fixed;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  /* background: orange; */
  background: #fff url("./../../assets/ballBtn.png") no-repeat;
  background-size: 50px 50px;
  line-height: 50px;
  text-align: center;
  color: #fff;
  z-index: 50;
}
.ballBtn img,
.ballBtn-vi img {
  width: 100%;
}
.ballBtn span,
.ballBtn-vi span {
  width: 40px;
  height: 40px;
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  border-radius: 50%;
}
.ballBtn-vi {
  background: url("./../../assets/vi/ballBtn.png") no-repeat;
  background-size: 50px 50px;
}
</style>
